<template>
	<v-dialog
		v-model="dialog"
		:max-width="selectedType.id ? 800 : 400"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
		@click:outside="closeDialog()"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn v-if="myPageBtn" text v-bind="attrs" v-on="on" @click="openMyPageDialog">
				依頼作成
			</v-btn>
			<v-btn
				v-else
				:text="text"
				:color="text ? 'white' : 'secondary'"
				:class="$vuetify.breakpoint.xs ? 'ml-2 pa-1 mx-2 my-1' : 'ml-2'"
				v-bind="attrs"
				v-on="on"
			>
				<v-icon class="mr-1">mdi-plus</v-icon>
				作成
			</v-btn>
		</template>

		<v-card :title="$vuetify.breakpoint.xs">
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">新規依頼作成</v-app-bar-title>
				<v-spacer />

				<v-btn icon dark @click="closeDialog()" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>

			<v-form class="pa-2" ref="form" v-model="valid">
				<v-row no-gutters justify="space-between">
					<v-select
						label="依頼の種類"
						:items="requirementTypes"
						item-text="name"
						item-value="value"
						:rules="[rules.required]"
						hint="作成する依頼の種類を選択してください"
						no-data-text="表示内容ががありません"
						class="mt-4 max-width-350px"
						outlined
						dense
						v-model="selectedType"
						return-object
						@change="checkRequirementType"
					/>

					<v-text-field
						label="サブタイトル"
						dense
						outlined
						:rules="[]"
						class="mt-4 max-width-350px"
						v-if="selectedType.id"
						v-model="requirement.subtitle"
					/>

					<v-text-field
						label="依頼納期(希望)"
						type="date"
						dense
						outlined
						:rules="[rules.required]"
						class="mt-4 max-width-350px"
						hint="依頼の希望納期を記入してください"
						v-if="selectedType.id"
						v-model="requirement.deadline"
					/>
					<v-row
						no-gutters
						v-if="!selectedMatter && selectedType.need_matter_flag"
						class="max-width-350px"
					>
						<v-text-field
							label="案件を検索"
							dense
							outlined
							:rules="[]"
							class="mt-4"
							hint="紐付けしたい案件の見積番号・受注番号を入力してください。"
							v-model="searchWord"
						/>
						<v-btn
							class="ma-2 pa-2 mt-4"
							:disabled="!searchWord"
							color="primary"
							@click="searchMatters()"
							>検索</v-btn
						>
					</v-row>
					<v-row
						v-if="searchedMatters"
						align="center"
						justify="space-around"
						no-gutters
						class="max-width-350px"
					>
						<p class="secondary--text" v-if="noMatterFlag">該当する案件データはありません</p>
						<v-btn
							height="auto"
							class="ma-2 pa-2"
							depressed
							v-for="matter in searchedMatters"
							:key="matter.id"
							@click="setMatter(matter)"
						>
							<div class="text-left">
								<p
									v-if="matter.name"
									class="pre-wrap"
									v-text="common.returnMatterInfoWithOrderNumber(matter)"
								></p>
							</div>
						</v-btn>
					</v-row>
					<v-card class="mx-auto my-2 selected-matter-card max-width-350px" v-if="selectedMatter">
						<v-card-text>
							<v-flex class="justify-space-between">
								<div class="">
									<p v-if="selectedMatter" class="pre-wrap">{{ getMatterInfo(selectedMatter) }}</p>
								</div>
								<v-icon @click="removeMatter">mdi-close</v-icon>
							</v-flex>
						</v-card-text>
					</v-card>
					<v-row v-if="selectedMatter" no-gutters class="d-block max-width-350px">
						<v-select
							v-if="!selectedMatter.contract"
							label="見積製品絞り込み"
							:items="selectedMatterProducts"
							item-text="name"
							item-value="value"
							hint="対象の製品を選択してください"
							no-data-text="対象なし/読み込み中"
							class="mt-4"
							outlined
							dense
							v-model="selectedMatterProduct"
							return-object
						/>
						<v-select
							v-if="selectedMatter.contract"
							label="受注製品絞り込み"
							:items="selectedMatterOrderedProducts"
							item-text="name"
							item-value="value"
							hint="対象の製番を選択してください"
							no-data-text="対象なし/読み込み中"
							class="mt-4"
							outlined
							dense
							v-model="selectedMatterOrderedProduct"
							return-object
						/>
						<v-select
							v-if="selectedMatterOrderedProduct != null"
							label="枝番で絞り込み"
							:items="selectedOrderIndividualInfos"
							item-text="name"
							item-value="value"
							hint="対象の枝番を選択してください"
							no-data-text="対象なし/読み込み中"
							class="mt-4"
							outlined
							dense
							v-model="selectedOrderIndividualInfo"
							return-object
						/>
					</v-row>
					<RequirementValueForm
						v-for="(column, index) in selectedType.requirement_columns"
						:key="index"
						:column="column"
						:value_data.sync="values[index]"
						class="max-width-350px"
					/>
					<v-textarea
						class="mt-4 max-width-350px"
						label="伝達事項"
						:rules="[]"
						hint="入力内容以外に担当する方に伝えるべき内容を記載してください"
						outlined
						dense
						v-if="selectedType.id"
						v-model="requirement.message"
					/>
				</v-row>
			</v-form>
			<v-card-actions>
				<v-row no-gutters class="pb-2">
					<v-col cols="4"> </v-col>
					<v-col cols="4">
						<v-row no-gutters justify="center">
							<v-btn
								color="secondary"
								@click="openConfirm"
								:disabled="selectedType.id ? false : true"
							>
								<v-icon class="mr-2">mdi-checkbox-marked-outline</v-icon>
								確認する
							</v-btn>
						</v-row>
					</v-col>
					<v-col cols="4">
						<v-row no-gutters justify="end">
							<v-btn color="grey darken-1" text @click="closeDialog()"> 閉じる </v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
		<ComponentProcurementRequirementsNewDialog
			:dialog.sync="newComponentDialog"
			@resetForm="resetForm"
		/>
		<OrderComponentProcurementRequirementsNewDialog
			:dialog.sync="newOrderComponentDialog"
			@resetForm="resetForm"
		/>
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import rules from "../../../helper/rules"
import common from "../../../helper/common"
import RequirementValueForm from "./RequirementValueForm.vue"
import ComponentProcurementRequirementsNewDialog from "../../component_procurement_requirement/components/ComponentProcurementRequirementsNewDialog.vue"
import OrderComponentProcurementRequirementsNewDialog from "../../component_procurement_requirement/components/OrderComponentProcurementRequirementsNewDialog.vue"

function initialState() {
	return {
		rules: rules,
		common: common,
		multi: [],
		noMatterFlag: false,
		dialog: false,
		allRequired: false,
		requirement: {
			requirement_type_id: "",
			deadline: "",
			message: "",
			matter_id: "",
			subtitle: "",
		},
		selectedType: {
			requirement_columns: [],
		},
		searchWord: "",
		searchedMatters: [],
		selectedMatter: null,
		selectedMatterProducts: [],
		selectedMatterProduct: null,
		selectedMatterOrderedProducts: [],
		selectedMatterOrderedProduct: null,
		selectedOrderIndividualInfos: [],
		selectedOrderIndividualInfo: null,
		values: [],
		valid: false,
		dialogVisible: false,
		newComponentDialog: false,
		newOrderComponentDialog: false,
	}
}

export default {
	props: {
		text: Boolean,
		requirementTypes: Array,
		user: Object,
		myPageBtn: {
			type: Boolean,
			default: false,
			required: false,
		},
	},
	components: {
		RequirementValueForm,
		// TODO非同期で読み込む
		ComponentProcurementRequirementsNewDialog,
		OrderComponentProcurementRequirementsNewDialog,
	},
	data() {
		return initialState()
	},
	methods: {
		getMatterInfo(matter) {
			if (matter) {
				let baseText = "ランク：" + matter.situation + "`\n案件名：" + matter.name + "\n"
				let quotationText =
					"見積番号：" + matter.quotation_number + "-" + matter.quotation_sub_number + "\n"
				let orderText =
					"受注番号番号：" + (matter.order_number ? matter.order_number : "未受注") + "\n"
				let regularCustomerText = "得意先：" + matter.regular_customer_company.name + "\n"
				let customerText = "向け先：" + matter.customer_company.name
				return baseText + quotationText + orderText + regularCustomerText + customerText
			}
		},

		openMyPageDialog() {
			if (this.requirementTypes.length) return (this.dialog = true)
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/requirements/new", { headers })
				.then((res) => {
					this.$emit("requirement-new-data", res.data)
					this.dialog = true
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
					this.dialog = false
				})
		},
		openConfirm() {
			let confirmPackage = {
				requirement: this.requirement,
				selectedType: this.selectedType,
				matter: this.selectedMatter,
				matterProduct: this.selectedMatterProduct,
				orderedProduct: this.selectedMatterOrderedProduct,
				orderIndividualInfo: this.selectedOrderIndividualInfo,
				values: this.values,
				user: this.user,
			}
			this.$emit("openConfirm", confirmPackage)
		},
		validateForm() {
			this.$refs.form.validate()
		},
		setMatter(matter) {
			this.selectedMatter = matter
			this.searchedMatters = []
		},
		removeMatter() {
			this.selectedMatter = null
			this.selectedMatterProducts = []
			this.selectedMatterProduct = null
			this.selectedMatterOrderedProducts = []
			this.selectedMatterOrderedProduct = null
			this.selectedOrderIndividualInfos = []
			this.selectedOrderIndividualInfo = null
		},
		closeDialog() {
			if (this.dialog) {
				this.dialog = false
				Object.assign(this.$data, initialState())
			}
		},
		searchMatters() {
			this.noMatterFlag = false
			this.searchedMatters = []
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/matter_search.json", {
					headers,
					params: {
						q: { quotation_number_or_order_number_cont: this.searchWord },
						qq: { product_number_cont: this.searchWord },
					},
				})
				.then((response) => {
					this.searchedMatters = response.data.matters
					if (this.searchedMatters.length == 0) {
						this.noMatterFlag = true
					}
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},
		setRequirementValue(c) {
			let value = { requirement_column_id: c.id }
			switch (c.data_type) {
				case "target":
					value = { ...value, value_target_type: "", value_target_id: "", name: "" }
					break
				case "synchronization":
					value = { synchronized_data: {}, ...value, display_value: "" }
					break
				default:
					value[`value_${c.data_type}`] = null
			}
			return value
		},
		checkRequirementType() {
			if (this.selectedType.name == "部品調達依頼書(全ての部品)") {
				this.newComponentDialog = true
				this.dialog = false
			} else if (this.selectedType.name == "部品調達依頼書(受注済み製品部品)") {
				this.newOrderComponentDialog = true
				this.dialog = false
			}
		},

		resetForm() {
			Object.assign(this.$data, initialState())
		},
	},
	watch: {
		selectedType() {
			if (this.selectedType) {
				this.requirement.requirement_type_id = this.selectedType.id
				this.values = this.selectedType.requirement_columns.map((c) => this.setRequirementValue(c))
			} else {
				this.values = []
				this.requirement.requirement_type_id = ""
			}
		},
		selectedMatter() {
			if (this.selectedMatter) {
				this.requirement.matter_id = this.selectedMatter.id
				if (!this.selectedMatter.contract) {
					const headers = authenticate.setHeader()
					axios
						.get("/erp/v1/matter_products.json", {
							headers,
							params: {
								matter_id: this.selectedMatter.id,
							},
						})
						.then((response) => {
							this.selectedMatterProducts = response.data.matter_products
						})
						.catch((err) => {
							console.log(err)
							errorHandling.errorResponse(err)
						})
				} else {
					const headers = authenticate.setHeader()
					axios
						.get("/erp/v1/matter_ordered_products.json", {
							headers,
							params: {
								matter_id: this.selectedMatter.id,
							},
						})
						.then((response) => {
							this.selectedMatterOrderedProducts = response.data.ordered_products
						})
						.catch((err) => {
							console.log(err)
							errorHandling.errorResponse(err)
						})
				}
			} else {
				this.requirement.matter_id = ""
			}
		},
		selectedMatterOrderedProduct() {
			if (this.selectedMatterOrderedProduct) {
				if (this.selectedMatterOrderedProduct.id != null) {
					const headers = authenticate.setHeader()
					axios
						.get("/erp/v1/order_individual_infos.json", {
							headers,
							params: {
								op_id: this.selectedMatterOrderedProduct.id,
							},
						})
						.then((response) => {
							this.selectedOrderIndividualInfos = response.data.individual_infos
						})
						.catch((err) => {
							console.log(err)
							errorHandling.errorResponse(err)
						})
				}
			}
		},
	},
	computed: {},
}
</script>
<style scoped>
.selected-matter-card {
	max-width: 320px;
}
.max-width-350px {
	width: 100%;
	max-width: 350px;
}
</style>
